import { useParams } from 'react-router-dom';
import ReviewForm from '../../Components/Review/Form';

const PageReviewForm = () => {
  const bookingID = useParams().id;
  return <ReviewForm bookingID={bookingID} />;
}

export default PageReviewForm;